import { animate, style, transition, trigger } from '@angular/animations';
import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { API, DeviceFullDTO } from 'src/app/services/api/api';
import { ModalNavigationComponent } from 'src/app/services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from 'src/app/services/gui/modal/modal-navigation.service';
import { SbPairingResultComponent } from '../sb-pairing-result/sb-pairing-result.component';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-device-deletion',
  templateUrl: './sb-device-deletion.component.html',
  styleUrls: ['./sb-device-deletion.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate(250, style({ opacity: 1 }))]),
      transition(':leave', [animate(500, style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class SbDeviceDeletionComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  accept: boolean;

  loading: boolean;

  @Input() device: DeviceFullDTO;

  constructor(
    private api: API,
    private modalNavigation: ModalNavigationService,
    public translate: TranslateService,
    private destroyRef: DestroyRef
  ) {
    this.loading = false;
    this.accept = false;
  }

  ngOnInit() {
    this.accept = false;
    if (this.isInModalContext) {
      this.device = this.modalNavigation.getCurrentNavigation().data.device;
    }
  }

  goBack() {
    this.modalNavigation.goBack();
  }

  isSubmitValid() {
    return this.accept;
  }

  deleteDevice() {
    this.loading = true;
    this.api
      .ss_nm_Device_deleteDevice(this.device.id)
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: (e: boolean) => {
          if (e) {
            this.deleteSuccess();
          } else {
            this.deleteFail();
          }
        },
        error: () => {
          this.deleteFail();
        },
      });
  }

  deleteFail() {
    this.modalNavigation.navigate(SbPairingResultComponent, {
      device: this.device,
      mode: 'DELETE',
      success: false,
      message: this.translate.instant('lang.devices.deviceDeleteFailed'),
    });
  }

  deleteSuccess() {
    this.modalNavigation.clearAndNavigate(SbPairingResultComponent, {
      device: this.device,
      mode: 'DELETE',
      success: true,
      message: this.translate.instant('lang.devices.deviceDeleted'),
    });
  }
}
